/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import LottieComponent from '@components/Lottie';
import { useCurrentWorkspace, useDefaultWorkspace } from '@hooks/workspace';

function HomePageRedirect() {
  const { workspaceId: workspaceIdParam } = useParams();
  const defaultWorkspace = useDefaultWorkspace(false);
  const [currentWorkspace, setCurrentWorkspace] = useCurrentWorkspace(false);
  const [resolved, setResolved] = useState(false);
  const workspaceId =
    workspaceIdParam ?? currentWorkspace?.id ?? defaultWorkspace?.id;
  useEffect(() => {
    if (!workspaceId) {
      setResolved(true);
      return;
    }
    setResolved(false);
    setCurrentWorkspace(workspaceId).finally(() => setResolved(true));
  }, [workspaceId, setCurrentWorkspace]);

  const fullPageLoader = (
    <div className="page_spinner_overlay">
      <LottieComponent className="page_spinner" view="preloader" />
    </div>
  );

  if (!currentWorkspace) {
    if (!resolved) return fullPageLoader;
    if (defaultWorkspace)
      return <Navigate to={`/campaigns/all/${defaultWorkspace.id}`} replace />;
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/campaigns/all/${currentWorkspace.id}`} replace />;
}

export default HomePageRedirect;
